import { PropsWithChildren } from 'react';

import { OverflowTabs } from 'components';
import { NavigationLink } from 'components/NavigationLink';
import { useTranslation } from 'libs/i18n';
import { useNavigate } from 'libs/navigation';
import { useNavigationMenu } from 'libs/navigation/hooks/useNavigationMenu';

import { ContainerStyled } from './NavigationMenu.styles';

const LinkComponent = ({
  children,
  href,
  className,
}: { href: string; className?: string } & PropsWithChildren) => (
  <NavigationLink className={className} to={href}>
    {children}
  </NavigationLink>
);

export const NavigationMenu = () => {
  const { t } = useTranslation();

  const { paths } = useNavigate();

  const currentPath = paths[1] || '';

  const menu = useNavigationMenu();

  if (!menu || menu.length === 0) {
    return null;
  }

  return (
    <ContainerStyled as="nav" role="navigation">
      <OverflowTabs
        tabs={menu.map((tab) => ({
          id: tab.path,
          href: tab.path,
          label: t(tab.title),
          LinkComponent,
          value: tab.path,
        }))}
        value={currentPath}
      />
    </ContainerStyled>
  );
};
